// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Contact
export const CONTACT_US_FORM_SUCCESS = 'CONTACT_US_FORM_SUCCESS';
export const CONTACT_US_FORM_ERROR = 'CONTACT_US_FORM_ERROR';
